const APIS = {
  PORTAL_API: process.env.REACT_APP_PORTAL_API!,
  SENTINEL_API: process.env.REACT_APP_SENTINEL_API!,
};

export default APIS;
